import { Chip } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const StyledIconChip = styled(Chip)`
  cursor: pointer;
  font-weight: 400;
  background-color: ${colorTokens.chip.light};
  border-color: ${colorTokens.chip.border};
  padding: 14px 10px;
  padding-left: 2px;

  & > svg {
    width: 23px;
    height: 23px;
    padding: 4px;
    border-radius: 50%;
    background-color: ${colorTokens.chip.dark};
    color: ${colorTokens.text.contrast}!important;
  }
`;

export const StyledCarePartnerIconChip = styled(StyledIconChip)`
  cursor: pointer;
  font-weight: 400;
  background-color: ${colorPalette.white};
  border-color: ${colorTokens.plum.dark};
  padding: 14px 10px;
  padding-left: 2px;
  color: ${colorTokens.plum.dark};

  & > svg {
    width: 23px;
    height: 23px;
    padding: 4px;
    border-radius: 50%;
    background-color: ${colorPalette.plum250};
    color: ${colorTokens.text.contrast}!important;
  }
`;
